import { useNavigate } from 'react-router-dom'
import { Press } from '@dorixona/ui'
import { Icon } from '../../ui/Icon'

export interface LinkRowProps {
  title: string
  /** Что уже есть в разделе: основной адрес, последняя карта, «Добавить». */
  value: string
  to: string
}

/**
 * Вход в раздел кабинета («Мои адреса», «Мои карты»): название, справа — что
 * в разделе сейчас, чтобы не открывать его ради этого. Значение длинное
 * (улица) — в одну строку с многоточием. Строки стоят в общей карточке `.acc-links`.
 */
export function LinkRow({ title, value, to }: LinkRowProps) {
  const navigate = useNavigate()
  return (
    <Press
      squish="row"
      className="acc-pick"
      onPress={() => {
        void navigate(to)
      }}
    >
      <span className="t1">{title}</span>
      <span className="acc-pick__val acc-pick__val--clip">{value}</span>
      <Icon name="i-chev" size={16} />
    </Press>
  )
}
